// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2wvQk","inputWrap":"styles_inputWrap__8sBU_","input":"styles_input__Cr9sp"};